import { ActionType, createAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { DTO } from './types'

export const updateActiveChatMessageAction = createAction('@chat/UPDATE_ACTIVE_CHAT_MESSAGE')<DTO>()

const success = (state: ChatState, action: ActionType<typeof updateActiveChatMessageAction>): ChatState => {
  const activeChatMessages = state.activeChat.messages
  const messageIndex = activeChatMessages.findIndex(message => message.messageId === action.payload.oldMessageId)
  if (messageIndex === -1) return state
  const newMessages = [...activeChatMessages]
  newMessages[messageIndex] = {
    ...newMessages[messageIndex],
    messageId: action.payload.newMessageId,
    createdAt: action.payload?.newMessageMoment || newMessages[messageIndex]?.createdAt,
    moment: action.payload?.newMessageMoment || newMessages[messageIndex]?.moment,
    momment: action.payload?.newMessageMoment || newMessages[messageIndex]?.momment,
    status: action.payload?.newMessageStatus || newMessages[messageIndex]?.status
  }

  return {
    ...state,
    activeChat: { ...state.activeChat, messages: newMessages }
  }
}

export const updateActiveChatMessageHandle = { asyncAction: updateActiveChatMessageAction, success }
